export default "__VITE_PUBLIC_ASSET__092a4150__"